import utils from "@/utils/utils";
export default {
  // 新版平台图标，后面逐渐改变。
  publish_platform_new: {
    0: {
      label: "All",
      key: 0,
      value: 0,
      icon: ""
    },
    1: {
      label: "Facebook",
      key: 1,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/Facebook.webp"
    },
    2: {
      label: "X",
      key: 2,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/X.webp"
    },
    4: {
      label: "Instagram",
      key: 4,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/Instagram.webp"
    },
    5: {
      label: "TikTok",
      key: 5,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/TikTok.webp"
    },
    6: {
      label: "YouTube",
      key: 6,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/YouTube.webp"
    },
    7: {
      label: "LinkedIn",
      key: 7,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/linkedin.webp"
    },
    8: {
      label: "Telegram",
      key: 8,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/Telegram.webp"
    },
    3: {
      label: "WhatsApp",
      key: 3,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/WhatsApp.webp"
    },
    WhatsApp: {
      label: "WhatsApp",
      key: 3,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/WhatsApp.webp"
    },
    Shop: {
      label: "电商平台",
      // labelKey 优先于 label，用于平台列表的多语言展示。
      labelKey: "platform.Shop-Platform",
      key: 10,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logonew/Shop.webp"
    },
    AdAccount: {
      label: "广告账号",
      labelKey: "common.AdAccounts",
      key: "AdAccount",
      value: 0,
      icon: `${utils.imageRoot}/avatars/platform-ad-accounts.webp`
    }
  },
  publish_platform: {
    0: {
      label: "All",
      key: 0,
      value: 0,
      icon: ""
    },
    1: {
      label: "Facebook",
      key: 1,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Facebook.webp"
    },
    2: {
      label: "X",
      key: 2,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/X.webp"
    },
    4: {
      label: "Instagram",
      key: 4,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Instagram.webp"
    },
    5: {
      label: "TikTok",
      key: 5,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/TIKTOK.webp"
    },
    6: {
      label: "YouTube",
      key: 6,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/youtube.webp"
    },
    8: {
      label: "Telegram",
      key: 8,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/telegram.webp"
    },
    7: {
      label: "Linkedin",
      key: 7,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/linkedin.webp"
    }
  },
  // auth_page_total 在 platform_flag=3 时使用数字 3 返回 WhatsApp 数量；按需合并到主页选择页签。
  auth_page_total_platforms: {
    3: {
      label: "WhatsApp",
      key: 3,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Whatsapp.webp"
    }
  },
  // 成员社交账号筛选等静态平台下拉统一读取此配置，WhatsApp 使用后端平台编号 3。
  platform_config: {
    1: "Facebook",
    2: "X",
    3: "WhatsApp",
    4: "Instagram",
    5: "TikTok",
    6: "YouTube",
    7: "LinkedIn",
    8: "Telegram"
    // 9: "VK",
  },
  // 授权入口共用这里的平台配置；Facebook 与 Instagram 的前端申请权限分别维护。
  Authorization_platform: [{
    platform: 1,
    name: "Facebook",
    // Facebook 不请求 instagram_* 权限，避免授权弹窗要求选择 Instagram 专业账户。
    scopes: "ads_management,public_profile,read_insights,pages_manage_metadata,pages_messaging,pages_show_list,pages_read_engagement,pages_manage_engagement,email,pages_read_user_content,business_management,pages_manage_posts",
    about: "common.Facebook-desc",
    type: "page"
  }, {
    platform: 2,
    name: "X",
    about: "common.X-desc",
    type: "page"
  }, {
    platform: 5,
    name: "TikTok",
    about: "common.TikTok-desc",
    type: "page"
  }, {
    platform: 4,
    name: "Instagram",
    // Instagram 授权保留 instagram_* 权限，供 platform=4 的登录和重新授权使用。
    scopes: "ads_management,public_profile,read_insights,pages_manage_metadata,pages_messaging,pages_show_list,pages_read_engagement,pages_manage_engagement,email,pages_read_user_content,business_management,pages_manage_posts,instagram_manage_messages,instagram_basic,instagram_manage_insights,instagram_manage_comments,instagram_content_publish",
    about: "common.Instagram-desc",
    type: "page"
  }, {
    platform: 6,
    name: "YouTube",
    scopes: "",
    about: "common.YouTube-desc",
    type: "page"
  }, {
    platform: 8,
    name: "Telegram",
    scopes: "",
    about: "Telegram: a new era of messaging",
    type: "page"
  }, {
    platform: 7,
    name: "LinkedIn",
    scopes: "",
    about: "",
    disabled: true,
    type: "page"
  }, {
    platform: 'WhatsApp',
    name: "WhatsApp",
    scopes: "",
    about: "",
    type: "account"
  }, {
    platform: "Shop",
    name: "platform.Shop-Platform",
    scopes: "",
    about: "",
    type: "shop"
  },
  // {
  //   platform: 9,
  //   name: "VK",
  //   scopes: "",
  //   about: "common.VK-desc",
  // },
  {
    platform: "AdAccount",
    name: "common.AdAccounts",
    type: "account"
  }]
};
export const AuthorizationPlatformTypeConfigMap = new Map([["page", "common.PageAuth"], ["account", "common.AccountAuth"], ["shop", "common.ShopAuth"]]);